module.exports = __webpack_public_path__ + "static/media/brands.729d5071.webp";